export default "__VITE_ASSET__BTVfgkte__"